import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

// Accessible, tokenized modal with overlay and panel.
// Rendered through a portal to document.body so the overlay escapes any ancestor stacking
// context (e.g. a transform/filter wrapper) that would otherwise trap its fixed positioning
// below separately-mounted chrome like the sticky Succession header. Theme tokens are set on
// :root (document.documentElement) so they still resolve from body.
const Modal = ({ open, onClose, className, children, panelClassName, overlayClassName, overlayStyle }) => {
  if (!open) return null;
  const overlay = (
    <div className={overlayClassName || 'fixed inset-0 z-50 bg-black/40 animate-modal-fade-in'} style={overlayStyle} onClick={onClose}>
      <div
        className={
          panelClassName ||
          'absolute inset-0 flex items-center justify-center p-4'
        }
      >
        <div
          role="dialog"
          aria-modal="true"
          className={
            className ||
            'bg-succession-bg-primary text-succession-text-primary rounded-lg shadow-succession-lg border border-succession-border w-full max-w-lg animate-modal-scale-in'
          }
          onClick={(e) => e.stopPropagation()}
        >
          {children}
        </div>
      </div>
    </div>
  );

  return (typeof document !== 'undefined' && document.body)
    ? ReactDOM.createPortal(overlay, document.body)
    : overlay;
};

Modal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  className: PropTypes.string,
  panelClassName: PropTypes.string,
  overlayClassName: PropTypes.string,
  overlayStyle: PropTypes.object,
  children: PropTypes.node,
};

export default Modal;


